import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/usage/scope/usage.scopeCustomer.query.gql"
import type {
  UsageScopeCustomerQuery,
  UsageScopeCustomerQueryVariables,
} from "@/v2-backoffice-client/usage/scope/__types__/usage.scopeCustomer.query"

type Options = QueryHookOptions<
  UsageScopeCustomerQuery,
  UsageScopeCustomerQueryVariables
>

export function useUsageScopeCustomerQuery(options?: Options) {
  return useQuery<UsageScopeCustomerQuery, UsageScopeCustomerQueryVariables>(
    query,
    options,
  )
}
